import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const childProfiles = [
  { id: '1', childName: '小明', parentName: '张爸爸', grade: '小学四年级', region: '北京（城市）', interests: ['数学', '科学', '画画'], avatar: 'https://public.readdy.ai/ai/img_res/b4da0d57b792aecbbd6bd64964d1aa9d.jpg', desc: '我儿子性格开朗，学习认真，数学成绩优秀，希望找到同年级的小朋友一起学习交流。' },
  { id: '2', childName: '小花', parentName: '李妈妈', grade: '小学四年级', region: '湖南（农村）', interests: ['语文', '音乐', '舞蹈'], avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20girl%20student%20smiling%20portrait%2C%20primary%20school%20age%2C%20simple%20background&width=80&height=80&seq=cp002&orientation=squarish', desc: '我女儿来自农村，语文成绩很好，喜欢唱歌跳舞，希望认识城市的小朋友，开阔眼界。' },
  { id: '3', childName: '大壮', parentName: '王爸爸', grade: '初中二年级', region: '四川（农村）', interests: ['物理', '体育', '编程'], avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20teenage%20boy%20student%20portrait%2C%20middle%20school%20age%2C%20friendly%20smile&width=80&height=80&seq=cp003&orientation=squarish', desc: '我儿子对物理和编程很感兴趣，希望找到有共同爱好的同学一起探讨学习。' },
  { id: '4', childName: '晓雪', parentName: '赵妈妈', grade: '高中一年级', region: '上海（城市）', interests: ['英语', '历史', '写作'], avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20teenage%20girl%20student%20portrait%2C%20high%20school%20age%2C%20bright%20smile&width=80&height=80&seq=cp004&orientation=squarish', desc: '我女儿英语很好，喜欢写作，希望找到志同道合的同学，一起为高考做准备。' },
  { id: '5', childName: '小龙', parentName: '陈爸爸', grade: '小学六年级', region: '广州（城市）', interests: ['数学', '奥数', '围棋'], avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20boy%20student%20portrait%2C%20primary%20school%20age%2C%20intelligent%20look&width=80&height=80&seq=cp005&orientation=squarish', desc: '我儿子数学天赋很好，参加过奥数比赛，希望找到同样喜欢数学的小朋友一起切磋。' },
  { id: '6', childName: '小燕', parentName: '刘妈妈', grade: '初中一年级', region: '云南（农村）', interests: ['语文', '美术', '自然'], avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20girl%20student%20portrait%2C%20middle%20school%20age%2C%20warm%20smile%2C%20simple%20background&width=80&height=80&seq=cp006&orientation=squarish', desc: '我女儿来自云南农村，热爱大自然，美术很好，希望认识更多朋友，拓宽视野。' },
];

export default function ParentPage() {
  const [contactedIds, setContactedIds] = useState<Set<string>>(new Set());
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ childName: '', grade: '', region: '', interests: '', desc: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleContact = (id: string) => {
    setContactedIds((prev) => { const n = new Set(prev); n.add(id); return n; });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    setShowForm(false);
    setTimeout(() => setSubmitted(false), 3000);
  };

  return (
    <div className="min-h-screen bg-[#faf9f7]">
      <Navbar />
      <div className="relative pt-20 pb-10 bg-gradient-to-br from-amber-600 to-amber-800">
        <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
          <h1 className="text-3xl md:text-4xl font-black text-white mb-3">家长助力找学伴</h1>
          <p className="text-white/70 text-sm">家长帮孩子找同年级学伴，让孩子在互助中共同成长</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-8 py-10">
        {/* Post Profile CTA */}
        <div className="bg-gradient-to-r from-amber-500 to-amber-600 rounded-2xl p-6 mb-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="text-white">
            <h2 className="font-bold text-lg mb-1">为孩子发布学伴信息</h2>
            <p className="text-white/80 text-sm">填写孩子的年级、兴趣爱好，帮孩子找到志同道合的学习伙伴</p>
          </div>
          <button
            onClick={() => setShowForm(true)}
            className="px-6 py-3 bg-white text-amber-700 font-semibold rounded-full cursor-pointer hover:bg-amber-50 transition-colors whitespace-nowrap"
          >
            + 发布信息
          </button>
        </div>

        {submitted && (
          <div className="bg-green-50 border border-green-200 rounded-xl p-4 mb-6 flex items-center gap-2">
            <i className="ri-checkbox-circle-line text-green-600"></i>
            <span className="text-green-700 text-sm">信息发布成功！我们会尽快为您的孩子匹配合适的学伴。</span>
          </div>
        )}

        {/* Profiles Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {childProfiles.map((profile) => (
            <div key={profile.id} className="bg-white rounded-2xl p-5">
              <div className="flex items-start gap-3 mb-4">
                <img src={profile.avatar} alt={profile.childName} className="w-14 h-14 rounded-full object-cover object-top flex-shrink-0" />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="font-bold text-gray-900">{profile.childName}</span>
                    <span className="text-xs bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full">{profile.grade}</span>
                  </div>
                  <p className="text-gray-500 text-xs mt-0.5">{profile.region}</p>
                  <p className="text-gray-400 text-xs mt-0.5">家长：{profile.parentName}</p>
                </div>
              </div>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">{profile.desc}</p>
              <div className="flex flex-wrap gap-1 mb-4">
                {profile.interests.map((interest) => (
                  <span key={interest} className="text-xs bg-amber-50 text-amber-700 px-2.5 py-1 rounded-full">{interest}</span>
                ))}
              </div>
              <button
                onClick={() => handleContact(profile.id)}
                className={`w-full py-2.5 rounded-full text-sm font-semibold transition-all cursor-pointer whitespace-nowrap ${
                  contactedIds.has(profile.id) ? 'bg-green-100 text-green-700' : 'bg-amber-500 text-white hover:bg-amber-600'
                }`}
              >
                {contactedIds.has(profile.id) ? '已联系家长' : '联系家长'}
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Form Modal */}
      {showForm && (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl w-full max-w-md p-6">
            <div className="flex items-center justify-between mb-5">
              <h3 className="font-bold text-gray-900">发布孩子学伴信息</h3>
              <button onClick={() => setShowForm(false)} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 cursor-pointer">
                <i className="ri-close-line text-gray-500"></i>
              </button>
            </div>
            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
              <div>
                <label className="text-xs font-medium text-gray-600 mb-1 block">孩子姓名</label>
                <input
                  type="text"
                  value={formData.childName}
                  onChange={(e) => setFormData({ ...formData, childName: e.target.value })}
                  placeholder="请输入孩子姓名"
                  className="w-full bg-gray-50 rounded-xl px-4 py-2.5 text-sm outline-none"
                  required
                />
              </div>
              <div>
                <label className="text-xs font-medium text-gray-600 mb-1 block">年级</label>
                <select
                  value={formData.grade}
                  onChange={(e) => setFormData({ ...formData, grade: e.target.value })}
                  className="w-full bg-gray-50 rounded-xl px-4 py-2.5 text-sm outline-none cursor-pointer"
                  required
                >
                  <option value="">请选择年级</option>
                  {['小学一年级','小学二年级','小学三年级','小学四年级','小学五年级','小学六年级','初中一年级','初中二年级','初中三年级','高中一年级','高中二年级','高中三年级'].map(g => (
                    <option key={g} value={g}>{g}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="text-xs font-medium text-gray-600 mb-1 block">所在地区</label>
                <input
                  type="text"
                  value={formData.region}
                  onChange={(e) => setFormData({ ...formData, region: e.target.value })}
                  placeholder="如：北京（城市）/ 湖南（农村）"
                  className="w-full bg-gray-50 rounded-xl px-4 py-2.5 text-sm outline-none"
                  required
                />
              </div>
              <div>
                <label className="text-xs font-medium text-gray-600 mb-1 block">兴趣爱好（用逗号分隔）</label>
                <input
                  type="text"
                  value={formData.interests}
                  onChange={(e) => setFormData({ ...formData, interests: e.target.value })}
                  placeholder="如：数学、画画、音乐"
                  className="w-full bg-gray-50 rounded-xl px-4 py-2.5 text-sm outline-none"
                />
              </div>
              <div>
                <label className="text-xs font-medium text-gray-600 mb-1 block">孩子简介</label>
                <textarea
                  value={formData.desc}
                  onChange={(e) => setFormData({ ...formData, desc: e.target.value })}
                  placeholder="简单介绍一下孩子的性格、学习情况和希望找到什么样的学伴..."
                  className="w-full bg-gray-50 rounded-xl px-4 py-2.5 text-sm outline-none resize-none"
                  rows={3}
                  maxLength={500}
                />
              </div>
              <button type="submit" className="w-full py-3 bg-amber-500 text-white font-semibold rounded-full cursor-pointer hover:bg-amber-600 transition-colors whitespace-nowrap">
                发布信息
              </button>
            </form>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
